import { memo } from 'react';
import Typography from '@mui/material/Typography';
import { Setup } from 'features/setups/types';
import StatefulSelector from 'ui/widgets/StatefulSelector';
import { RootState } from 'infrastructure/store';
import { selectSetupGroupNames } from 'features/general/selectors';

type Props = {
    row: Setup<string>;
    updateGroupName: (groupName: string | null) => void
    selectedGroupName: string | null
}

const DialogContent = ({row, updateGroupName, selectedGroupName}: Props) => {

    const selectSetUpGroupName = (state: RootState) => (
        selectSetupGroupNames(state))
    return  (
    <>
        <Typography
            variant="h5"
            gutterBottom
            sx={{
                fontSize: '24px'
            }}
        >
            Are you sure you want to create a group for this setup?
        </Typography>

        <StatefulSelector
                               fullWidth
                               disableClearable
                               layout={null}
                               size='small'
                               selectOptions={selectSetUpGroupName}
                               value={selectedGroupName}
                               TextFieldProps={{
                                   name: 'groupName',
                                   label: 'Group Name'
                               }}
                               onChange={(_, option) => {
                                      updateGroupName(option);
                               }}
                               FormControlProps={{
                                   sx: {
                                       width: '100%'
                                   }
                               }}
                           />

    </>
)};

export default memo(DialogContent);
